import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as UpButton } from '../../../assets/upButton.svg';
import { ReactComponent as DownButton } from '../../../assets/downButton.svg';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface BookDescriptionProps {
    description?: string;
}

const BookDescription: React.FC<BookDescriptionProps> = ({ description }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isMobile = useIsMobile();

    if (!description) return null;

    const isLong = description.length > 200;
    const displayText = isExpanded
        ? description
        : description.slice(0, 200) + (isLong ? '...' : '');

    return (
        <div className="flex flex-col gap-3">
            <p className={`font-bold text-black ${isMobile ? 'text-[24px]' : 'text-[40px]'}`}>
                작품설명
            </p>
            <p
                className={`font-namsan whitespace-pre-line ${
                    isMobile
                        ? 'text-[15px] text-[#333] leading-[1.6]'
                        : 'text-[20px] text-[#565659] leading-[1.8]'
                }`}
            >
                {displayText}
            </p>
            {isLong && (
                <div className="flex justify-end">
                    <motion.button
                        onClick={() => setIsExpanded(!isExpanded)}
                        whileHover={{ x: 6 }}
                        transition={{ type: "spring", stiffness: 500, damping: 25 }}
                        className={`flex flex-row items-center gap-1.5 text-[#565659] font-namsan ${
                            isMobile ? 'text-[16px]' : 'text-[18px]'
                        }`}
                    >
                        {isExpanded ? (
                            <><UpButton /><span>접기</span></>
                        ) : (
                            <><DownButton /><span>더보기</span></>
                        )}
                    </motion.button>
                </div>
            )}
        </div>
    );
};

export default BookDescription;
